export default __webpack_public_path__ + "static/Rabbit-star-e2b5d0cfacc0154e25ccdef0fd6e25ad.svg";